unit UImageShowForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, UAttachmentModel,
  WEBLib.Buttons, UEssentialHelper;

type
  TImageShowForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlImage: TPanel;
    img: TImageControl;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
  private
    FMainConfig: TMainConfig;
    FAttachment: TAttachmentModel;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetAttachment(const Value: TAttachmentModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Attachment: TAttachmentModel read FAttachment write SetAttachment;
  protected procedure LoadDFMValues; override; end;

var
  ImageShowForm: TImageShowForm;

implementation

uses
  WEBLib.LocalFiles;

{$R *.dfm}
{ TForm1 }

procedure TImageShowForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TImageShowForm.SetAttachment(const Value: TAttachmentModel);
var
  tFile: TTextFile;
  procedure HandleFileOpen(Sender: TObject);
  var
    myFile: TTextFile;
  begin
    if Sender is TTextFile then
    begin
      myFile := Sender as TTextFile;
      img.URL := myFile.Text;
    end;
    Self.WebFormResize(Self);
  end;

begin
  FAttachment := Value;
  if (Self.Attachment <> nil) and (Self.Attachment.Kind = akPicture) then
  begin
    tFile := TTextFile.Create(Self);
    tFile.OnFileOpen := HandleFileOpen;
    tFile.OpenFile(Self.Attachment.FakNr + '\Pictures',
      Self.Attachment.Filename);
  end;
end;

procedure TImageShowForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
end;

procedure TImageShowForm.WebFormResize(Sender: TObject);
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Bildanzeige';
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := True;
    lblHeader.Caption := 'Winzeit - WebPortal - Bildanzeige';
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  FormatImage(img, pnlImage.ClientWidth, pnlImage.ClientHeight);
end;

procedure TImageShowForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlImage := TPanel.Create(Self);
  img := TImageControl.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlImage.BeforeLoadDFMValues;
  img.BeforeLoadDFMValues;
  try
    Name := 'ImageShowForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UImageShowForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Bildanzeige';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UImageShowForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlImage.SetParentComponent(Self);
    pnlImage.Name := 'pnlImage';
    pnlImage.Left := 0;
    pnlImage.Top := 64;
    pnlImage.Width := 640;
    pnlImage.Height := 392;
    pnlImage.Align := alClient;
    pnlImage.Caption := 'pnlImage';
    pnlImage.ChildOrder := 2;
    pnlImage.ShowCaption := False;
    img.SetParentComponent(pnlImage);
    img.Name := 'img';
    img.Left := 0;
    img.Top := 0;
    img.Width := 400;
    img.Height := 300;
    img.HeightPercent := 100.000000000000000000;
    img.WidthPercent := 100.000000000000000000;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlImage.AfterLoadDFMValues;
    img.AfterLoadDFMValues;
  end;
end;

end.
